//GeneratorFlag:[NoChange]
import PersonMilitary from './person-military';
import PersonMilitaryFilter from './person-military-filter';

export default {PersonMilitary, PersonMilitaryFilter}
export{PersonMilitary, PersonMilitaryFilter}